import EventPreview from "./EventPreview"

export default EventPreview;